import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

function FormH6Preview({ ...props }) {
  const { field: { label } } = useFormFieldContext()

  return <BasePreview {...props}>
    <h6>{label}</h6>
  </BasePreview>
}

export default define('form-heading-h6', FormH6Preview, Fragment)
  .shared(prop.share('FormH6', 'form-heading-h6'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

